var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reset_phone",
    transform: "translate(106 -8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-106 8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cfde929122150d98f45f879fd1f3ec89",
    transform: "translate(-105.439 7016.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 60,
    height: 60,
    rx: 5.494,
    transform: "translate(1.439 1096.636)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile_security_1_",
    transform: "translate(13.406 1107.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18565",
    "data-name": "Group 18565",
    transform: "translate(8 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24631",
    "data-name": "Path 24631",
    d: "M26.812,2H9.254A1.258,1.258,0,0,0,8,3.254V30.845A1.258,1.258,0,0,0,9.254,32.1v-6.17a3.866,3.866,0,0,1,2.609-3.637,6.252,6.252,0,0,1,12.34,0,3.849,3.849,0,0,1,2.609,3.637V32.1a1.258,1.258,0,0,0,1.254-1.254V3.254A1.258,1.258,0,0,0,26.812,2ZM19.287,8.258H16.779a1.254,1.254,0,0,1,0-2.508h2.508a1.254,1.254,0,1,1,0,2.508Z",
    transform: "translate(-8 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24632",
    "data-name": "Path 24632",
    d: "M23.541,22.371a1.357,1.357,0,0,0-1.354-1.354H21.045V19.762h-.013a3.762,3.762,0,1,0-7.525,0v1.254H12.417A1.364,1.364,0,0,0,11,22.371V32.3a1.258,1.258,0,0,0,1.254,1.254H22.287A1.258,1.258,0,0,0,23.541,32.3Zm-5.016-1.354H16.016V19.762a1.254,1.254,0,1,1,2.508,0Z",
    transform: "translate(-7.238 1.558)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPhone);
export default __webpack_public_path__ + "static/media/reset_phone.6d3700a84a2bca1763d77cc7beab2cc9.svg";
export { ForwardRef as ReactComponent };